import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledHero = styled.section`
	background-color: ${CSSVars.gray700};
	padding: 50px 20px 50px;
	display: flex;
	gap: 50px;
	max-width: 1420px;
	margin: 0 auto;
	justify-content: space-between;
	flex-wrap: wrap;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 160px 40px 100px;
	}

	.hero-content-container {
		color: ${CSSVars.white};
		position: relative;
		width: 100%;
		max-width: 870px;
		flex: 500px;

		.app-header {
			display: flex;
			justify-content: space-between;
			gap: 20px;
			margin: 20px 0 50px;
			flex-wrap: wrap;

			.left-side {
				display: flex;
				gap: 20px;

				img {
					width: 100px;
					height: 100px;
					min-width: 100px;
					min-height: 100px;
					border-radius: 5px;
					background-color: #fff;
				}

				.details {
					h1 {
						font-weight: 600;
						max-width: 400px;
						position: relative;
						z-index: 10;
						font-size: ${CSSVars.fontSize2XL};

						@media screen and (min-width: ${CSSVars.breakpointXL}) {
							font-size: ${CSSVars.fontSize4XL};
						}
					}

					h2 {
						font-weight: 300;
						max-width: 400px;
						font-size: ${CSSVars.fontSizeLG};
						position: relative;
						z-index: 10;
						margin: 10px 0 0;

						@media screen and (min-width: ${CSSVars.breakpointXL}) {
							font-size: ${CSSVars.fontSizeXL};
						}
						span {
							color: ${CSSVars.primary500};
						}
					}
				}
			}

			.install-btn {
				height: fit-content;
				padding: 16px 30px;
			}
		}

		.app-info {
			white-space: break-spaces;

			h3 {
				font-weight: 600;
				font-size: ${CSSVars.fontSizeLG};
			}

			.info-text {
				font-weight: 300;
				font-size: ${CSSVars.fontSizeMD};
				margin: 20px 0 50px;
			}

			.heading-2 {
				margin: 0 0 40px;
				font-size: 24px;
				color: ${CSSVars.white};

				&:not(:first-of-type) {
					margin-top: 60px;
				}
			}

			pre {
				white-space: break-spaces;
			}

			em {
				color: ${CSSVars.white};
			}

			p {
				margin: 0 0 20px;
				line-height: 1.7;
			}

			a {
				color: inherit;
				text-decoration: underline;

				&:hover {
					color: ${CSSVars.primary500};
				}
			}

			> div {
				font-size: 16px;
				font-weight: 200;
				line-height: 1.7;
				margin-bottom: 20px;
			}

			*:not(br) + br {
				display: none;
			}

			ul,
			ol {
				list-style: disc;
				margin: 0 30px;

				li {
					margin: 0 0 10px;
					line-height: 1.7;
				}
			}

			h2 {
				margin: 0 0 20px;
				font-size: 24px;
				list-style: 1.7;
				font-weight: 500;
				color: ${CSSVars.white};
			}

			h3 {
				margin: 0 0 20px;
				font-size: 20px;
				list-style: 1.7;
				font-weight: 500;
				color: ${CSSVars.white};
			}

			h4 {
				margin: 0 0 20px;
				font-size: 18px;
				list-style: 1.5em;
				font-weight: 500;
				color: ${CSSVars.gray200};
			}

			h5 {
				margin: 0 0 20px;
				font-size: 14px;
				list-style: 1.7;
				font-weight: 500;
				color: ${CSSVars.gray200};
			}

			button,
			script,
			code,
			iframe {
				display: none;
			}
		}
	}

	.cards {
		width: 100%;
		max-width: 450px;
		flex: 350px;
		display: flex;
		flex-direction: column;
		gap: 30px;

		.card {
			background-color: ${CSSVars.gray600};
			border: 1px solid #2a2e42;
			border-radius: 5px;
			padding: 30px;
			color: ${CSSVars.white};

			h3 {
				font-weight: 600;
				font-size: ${CSSVars.fontSizeLG};

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			p {
				font-size: ${CSSVars.fontSizeSM};
				font-weight: 400;
				color: ${CSSVars.white};

				&.title {
					color: ${CSSVars.gray400};
					min-width: 70px;

					@media screen and (min-width: ${CSSVars.breakpointLG}) {
						min-width: 100px;
					}
				}
			}

			&.info {
				display: flex;
				flex-direction: column;
				gap: 20px;

				.stat {
					display: flex;
					gap: 20px;

					.tags {
						display: flex;
						flex-wrap: wrap;
						gap: 10px;

						.tag {
							border-radius: 20px;
							padding: 5px 12px;
							background-color: ${CSSVars.primary500};
							font-size: ${CSSVars.fontSizeSM};
							font-weight: 500;
						}
					}
				}
			}

			&.promo {
				text-align: center;
				background-color: #353d58;
				border: 1px solid #727ca4;

				p {
					font-size: ${CSSVars.fontSizeMD};
					font-weight: 300;
					margin: 10px 0 10px;

					@media screen and (min-width: ${CSSVars.breakpointLG}) {
						font-size: ${CSSVars.fontSizeLG};
					}
				}
				.img-link {
					border: none;
					margin: 0 auto;
					&:hover {
						background: none;
					}

					img {
						/* max-width: 100%; */
						/* max-height: 100%; */
						/* width: 300px; */
						width: 100%;
						height: 100%;
					}
				}

				.cta {
					margin: 10px auto 0;
					font-size: ${CSSVars.fontSizeMD};
					padding: 12px 25px;

					@media screen and (min-width: ${CSSVars.breakpointLG}) {
						font-size: ${CSSVars.fontSizeXL};
					}
				}
			}
		}
	}
`;
